export interface PaymentMethod {
  id: string
  name: string
  logo: string
}

export const paymentMethods: PaymentMethod[] = [
  {
    id: 'mercado-pago',
    name: 'Mercado Pago',
    logo: 'https://cdn.magicpatterns.com/uploads/29G6PdA6V4Ztn9ndWXmFcJ/IMG_0501.jpg',
  },
  {
    id: 'pago-facil',
    name: 'Pago Fácil',
    logo: 'https://cdn.magicpatterns.com/uploads/qUyeesiy5hkaC9x24ERF7w/IMG_0500.jpg',
  },
  {
    id: 'rapipago',
    name: 'Rapipago',
    logo: 'https://cdn.magicpatterns.com/uploads/2fmv7ZNLUUWf4VGaeeGXg6/IMG_0499.png',
  },
  {
    id: 'transferencia',
    name: 'Transferencia bancaria',
    logo: 'https://cdn.magicpatterns.com/uploads/dzkkmSoFCFL6YpEtgSJ5s9/IMG_0502.jpg',
  },
]
